import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import {
  useGetCryoActionButtons,
  useFetchCryoprotectants,
  useSaveNUpdateCryoprotectantsHandler,
} from './hooks';
import React, { useEffect, useState } from 'react';
import { ProtectantAgents } from '.';
import { cryoprotectantColumns } from './utils';
import { useCryoprotectants } from 'redux/hooks/synchrotron';
import { ProtectantAgentType } from './constants';
import { ModalDetails } from 'business/models/CustomModels';
import { useCurrentWell } from 'redux/hooks/crystal';

const Cryoprotectant = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const cryoList = useCryoprotectants();
  const [_cryoList, _setCryoList] = useState(cryoList);
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: '',
    heading: 'Warning',
    isOkOnly: false,
    okButtonText: 'Proceed',
    noButtonText: 'Cancel',
    showButtons: true,
    isCancelOnly: false,
  });

  useFetchCryoprotectants();
  const saveUpdateCryoHandler = useSaveNUpdateCryoprotectantsHandler();
  const actionButtons: RMCustomButtonProps[] = useGetCryoActionButtons(
    _cryoList,
    _setCryoList,
    selectedRows,
    setSelectedRows,
    editId,
    setEditId,
    setModalDetails,
  );
  const currentWell = useCurrentWell();

  useEffect(() => {
    _setCryoList(
      cryoList.filter(
        (cryo) => !cryo.sourceWellId || cryo.sourceWellId === currentWell?.wellId,
      ),
    );
    setEditId(null);
  }, [cryoList, currentWell?.wellId]);

  return (
    <ProtectantAgents
      protectantAgentType={ProtectantAgentType.Cryoprotectant}
      buttons={actionButtons}
      tableProps={{
        columns: [...cryoprotectantColumns],
        data: _cryoList,
        selectedIds: selectedRows,
      }}
      setSelectedRows={setSelectedRows}
      editedData={editedData}
      setEditedData={setEditedData}
      setProtectantData={_setCryoList}
      editId={editId}
      setEditId={setEditId}
      saveUpdateProtectantHandler={saveUpdateCryoHandler}
      modalDetails={modalDetails}
      setModalDetails={setModalDetails}
    />
  );
};

export default Cryoprotectant;
